import * as React from "react";
import { useTranslation } from "react-i18next";
import i18n from "i18n";
import { useMemo } from "react";
import SecurityRoutes from "security-app/routing/Routes";
import StepActionButton from "./StepActionButton";
import StepGoToDashboard from "./StepGoToDashboard";
import StepPerformSearch from "./StepPerformSearch";
import StepSendNotification from "./StepSendNotification";
const stepActionLabel = (key) => i18n.t(`step_action_types.${key}`, { ns: "enterprise_security_events" });
export const STEP_READABLE_ACTION_TYPES = {
  get go_to_dashboard() {
    return stepActionLabel("view_dashboard");
  },
  get execute_notification() {
    return stepActionLabel("run_notification");
  },
  get perform_search() {
    return stepActionLabel("search");
  },
  get link() {
    return stepActionLabel("link");
  }
};
const getActionUrl = (stepId, eventId) => {
  const stepParam = `stepId=${stepId}`;
  const eventParam = eventId ? `&eventId=${eventId}` : "";
  const params = stepParam + eventParam;
  return `${SecurityRoutes.CORE_EVENTS.EVENT_PROCEDURES.executeAction()}?${params}`;
};
function StepActionsButton({ step, eventId = void 0 }) {
  var _a, _b, _c, _d;
  const { t } = useTranslation("enterprise_security_events");
  const actionUrl = useMemo(() => getActionUrl(step.id, eventId), [step, eventId]);
  switch ((_b = (_a = step == null ? void 0 : step.action) == null ? void 0 : _a.config) == null ? void 0 : _b.type) {
    case "go_to_dashboard":
      return /* @__PURE__ */ React.createElement(StepGoToDashboard, { actionUrl, config: (_c = step == null ? void 0 : step.action) == null ? void 0 : _c.config });
    case "execute_notification":
      return /* @__PURE__ */ React.createElement(StepSendNotification, { step, eventId });
    case "perform_search":
      return /* @__PURE__ */ React.createElement(StepPerformSearch, { actionUrl, config: (_d = step == null ? void 0 : step.action) == null ? void 0 : _d.config });
    case "link":
      return /* @__PURE__ */ React.createElement(StepActionButton, { title: t("step_actions_button.go_to_link"), to: actionUrl });
    default:
      return null;
  }
}
export default StepActionsButton;
